"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function elementDistVertical(a, b, cfg) {
    if (cfg === void 0) { cfg = { value: 5 }; }
    var dist = Math.abs(a.bottom - b.top);
    return Math.round(dist) >= cfg.value;
}
exports.default = {
    type: 'chain',
    usage: 'compare',
    expression: elementDistVertical,
};
//# sourceMappingURL=element-dist-vertical.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/util/responsive/constraints/element-dist-vertical.js
// module id = 1026
// module chunks = 37